import React, { Fragment } from "react";
import { Routes, Route } from "react-router-dom";

// Home Pages
// import HomeOne from "../pages/HomeOne";
import HomeTwo from "../pages/HomeTwo";
// import HomeThree from "../pages/HomeThree";

// About Page
import About from "../pages/About";

// Blog Pages
import Blog from "../pages/Blog";
import BlogGrid from "../pages/BlogGrid";
import BlogDetails from "../pages/BlogDetails";

// Pricing Plans Page
// import PricePlan from "../pages/PricePlan";

// Service Pages
import Service from "../pages/Service";
// import ServiceDetails from "../pages/ServiceDetails";
import WebDevelopment from "../pages/WebDevelopment";
import CustomSoftwareSolutions from "../pages/CustomSoftwareSolutions";
import AppDevelopment from "../pages/AppDevelopment";
import ERPSolutions from "../pages/ERPSolutions";
import WebApplications from "../pages/WebApplications";
import ITConsulting from "../pages/ITConsulting";
import ITSupportMaintenance from "../pages/ITSupportMaintenance";
import SapSolutionsSupport from "../pages/SapSolutionsSupport";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";
import MobileAppDevelopment from "../pages/MobileAppDevelopment";
import ManagedITServices from "../pages/ManagedITServices";

// Team Pages
// import Team from "../pages/Team";
// import TeamDetails from "../pages/TeamDetails";

// Project Pages
// import Project from "../pages/Project";
// import ProjectDetails from "../pages/ProjectDetails";

// Contact Page
import Contact from "../pages/Contact";

// Not Fouond Page
import NotFound from "../pages/NotFound";

const AppRouters = () => (
  <Fragment>
    <Routes>
      {/* <Route path="/" exact element={<HomeOne />} /> */}
      <Route path="/" exact element={<HomeTwo />} />
      {/* <Route path="/home-three" exact element={<HomeThree />} /> */}
      <Route path="/about" exact element={<About />} />
      {/* <Route path="/price-plan" exact element={<PricePlan />} /> */}
      <Route path="/service" exact element={<Service />} />
      {/* <Route path="/services/service-details" exact element={<ServiceDetails />} /> */}
      <Route path="/services/web-development" exact element={<WebDevelopment />} />
      <Route
        path="/services/custom-software-solutions"
        exact
        element={<CustomSoftwareSolutions />}
      />
      <Route path="/services/app-development" exact element={<AppDevelopment />} />
      <Route path="/services/erp-enterprise-solutions" exact element={<ERPSolutions />} />
      <Route
        path="/services/web-applications"
        exact
        element={<WebApplications />}
      />
      <Route path="/services/it-consulting" exact element={<ITConsulting />} />
      <Route
        path="/services/it-support-maintenance"
        exact
        element={<ITSupportMaintenance />}
      />
      <Route
        path="/services/sap-solutions-support"
        exact
        element={<SapSolutionsSupport />}
      />
      <Route
        path="/services/mobile-app-development"
        exact
        element={<MobileAppDevelopment />}
      />
      <Route
        path="/services/managed-it-services"
        exact
        element={<ManagedITServices />}
      />
      {/* <Route path="/project" exact element={<Project />} />
      <Route path="/project-details" exact element={<ProjectDetails />} /> */}
      {/* <Route path="/team" exact element={<Team />} />
      <Route path="/team-details" exact element={<TeamDetails />} /> */}
      <Route path="/blog" exact element={<Blog />} />
      <Route path="/blog-grid" exact element={<BlogGrid />} />
      <Route path="/blog/:slug" exact element={<BlogDetails />} /> 
      <Route path="/contact" exact element={<Contact />} />
      <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" exact element={<TermsAndConditions />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Fragment>
);

export default AppRouters;
